export interface CustomerVasActionTypes {
  type: CustomerVasActions;
  payload?: any;
}

export enum CustomerVasActions {
  CREATE_CUSTOMER_VAS = "CREATE_CUSTOMER_VAS",
  GET_CUSTOMER_VAS_LIST = "GET_CUSTOMER_VAS_LIST",
  SET_CUSTOMER_VAS_LIST = "SET_CUSTOMER_VAS_LIST",
  SET_CUSTOMER_VAS_LIST_PAGE_COUNT = "SET_CUSTOMER_VAS_LIST_PAGE_COUNT",
  GET_CUSTOMER_VAS_DATA_BY_ID = "GET_CUSTOMER_VAS_DATA_BY_ID",
  SET_CUSTOMER_VAS_DATA_BY_ID = "SET_CUSTOMER_VAS_DATA_BY_ID",
  EDIT_CUSTOMER_VAS_DATA_BY_ID = "EDIT_CUSTOMER_VAS_DATA_BY_ID",
}
